import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { AttributeLabels } from "@interfaces/attributeLabels";
import { fetchAttributeLabels } from "./attributeLabels.thunk";

const initialState: AttributeLabels = {};

export const attributeLabelsSlice = createSlice({
  name: "attributeLabels",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      fetchAttributeLabels.fulfilled,
      (state, action: PayloadAction<AttributeLabels | null>) => {
        if (action.payload) {
          return action.payload;
        }
        return state;
      }
    );
  },
});

export default attributeLabelsSlice.reducer;
